import { notifications } from '@mantine/notifications';
import { IconBell } from '@tabler/icons-react';

export const notifyOfNewTicket = () =>
    notifications.show({
        color: 'red',
        autoClose: true,
        title: 'Уведомление',
        message: 'Новый тикет!',
        icon: <IconBell />,
    });
